module.exports = __webpack_public_path__ + "static/media/gallery4.dc8a2600.jpg";